import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const variants = {
  primary: "bg-coral text-cream hover:bg-[#ff6f56]",
  secondary: "bg-teal text-cream hover:bg-[#15bdb0]",
  accent: "bg-sunny text-charcoal hover:bg-[#ffd15f]",
  white: "bg-white text-charcoal hover:bg-cream",
};

const sizes = {
  md: "px-6 py-3 text-base",
  lg: "px-8 py-4 text-lg md:text-xl",
};

export function Btn({ as = "button", to, href, variant = "primary", size = "lg", className, children, ...props }) {
  const cls = cn(
    "inline-flex items-center justify-center gap-2 font-heading font-bold rounded-full border-2 border-charcoal",
    "shadow-brut hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-brutsm active:translate-x-[4px] active:translate-y-[4px] active:shadow-none",
    "transition-[transform,box-shadow,background-color] duration-150",
    variants[variant], sizes[size], className
  );
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
}
